<div class="modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="close()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main">Datos Fiscales</div>
          <div class="title-sub">Registro de Pago y Factura</div>
        </div>
      </div>
    </div>
  </ion-header>

  <ion-content class="modal-content">
    <div class="form-container">
      <ion-grid>
        <ion-row>
          <!-- Sección Fiscal -->
          <ion-col size="12">
            <div class="section-title">Información Fiscal</div>
          </ion-col>

          <ion-col size="12">
            <div class="input-group">
              <ion-label class="field-label">No. Factura Fiscal</ion-label>
              <div class="modern-item">
                <input type="number" [(ngModel)]="fiscalData.factura_fiscal" class="native-input" placeholder="Ej: 12345">
              </div>
            </div>
          </ion-col>

          <ion-col size="12">
            <div class="input-group">
              <ion-label class="field-label">Fecha Factura Fiscal</ion-label>
              <div class="modern-item date-item">
                <input type="date" [(ngModel)]="fiscalData.fecha_factura_fiscal" class="native-input native-date">
                <ion-icon name="calendar-outline" class="date-icon"></ion-icon>
              </div>
            </div>
          </ion-col>

          <!-- Sección Pago -->
          <ion-col size="12">
            <div class="section-title" style="margin-top: 20px; border-left-color: #27ae60; color: #27ae60;">Detalles de Pago</div>
          </ion-col>

          <ion-col size="12">
            <div class="input-group">
              <ion-label class="field-label">Tipo de Pago</ion-label>
              <div class="modern-item select-item" (click)="selectTipoPago()">
                <div class="select-content">
                  <span class="select-value" [class.placeholder]="!fiscalData.tipo_pago">
                    {{ fiscalData.tipo_pago || 'Seleccionar tipo...' }}
                  </span>
                  <ion-icon name="chevron-down-outline" class="select-chevron"></ion-icon>
                </div>
              </div>
            </div>
          </ion-col>

          <ion-col size="12">
            <div class="input-group">
              <ion-label class="field-label">Fecha de Pago</ion-label>
              <div class="modern-item date-item">
                <input type="date" [(ngModel)]="fiscalData.fecha_pago" class="native-input native-date">
                <ion-icon name="calendar-outline" class="date-icon"></ion-icon>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-content>

  <div class="form-footer-actions">
    <ion-button class="cancel-modal-btn" (click)="confirmDelete()">
      Limpiar
    </ion-button>
    <ion-button class="save-btn" (click)="confirmSave()">
      Guardar
    </ion-button>
  </div>
</div>
